module.exports = __webpack_public_path__ + "img/质量监测select.2239aad8.svg";